<loading-layout #loadingLayout>
    <actividad-form *ngIf="actividad" [actividad]="actividad" (save)="save($event)"></actividad-form>
</loading-layout>
